// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"styles_sidebar__VtPxY","sidebarVisible":"styles_sidebarVisible__oaGHB","sidebarItem":"styles_sidebarItem__3p3EY"};